export default {
  setDataLastManifest: ({ commit }: any, lastManifestId: any) => {
    commit('SET_DATA_LAST_MANIFEST', lastManifestId)
  },
  setDataLastRoute: ({ commit }: any, lastRoute: any) => {
    commit('SET_DATA_LAST_MANIFEST', lastRoute)
  },
}
